import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: #1e1a3c;
  color: #e0e0e0;
  padding: 3rem 0;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  @media (min-width: 640px) {
    padding: 0 1.5rem;
  }
  @media (min-width: 1024px) {
    padding: 0 2rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const FooterSection = styled.div`
  &.col-span-2 {
    @media (min-width: 768px) {
      grid-column: span 2 / span 2;
    }
  }
`;

const FooterTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #ffffff;
`;

const FooterLink = styled(Link)`
  color: #b0b0b0;
  text-decoration: none;
  transition: color 0.3s ease;
  display: block;
  margin-bottom: 0.5rem;
  &:hover {
    color: #00c4b4;
  }
`;

const FooterAnchor = styled.a`
  color: #b0b0b0;
  text-decoration: none;
  transition: color 0.3s ease;
  display: block;
  margin-bottom: 0.5rem;
  &:hover {
    color: #00c4b4;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
`;

const FooterBottom = styled.div`
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #374151;
  font-size: 0.875rem;
  color: #b0b0b0;
`;

const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
`;

const PolicyLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  @media (min-width: 768px) {
    justify-content: flex-end;
  }
`;

function Footer() {
  console.log('Footer rendering');

  return (
    <FooterContainer>
      <Container>
        <Grid>
          <FooterSection className="col-span-2">
            <Link to="/" className="text-2xl font-bold text-white">
              TokenClub
            </Link>
            <p className="mt-4 text-gray-400">
              Create, launch, and manage Solana tokens with ease. Built with Token 2022 Program for advanced features and capabilities.
            </p>
            <SocialLinks>
              <FooterAnchor href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                <i className="ri-twitter-x-line text-xl"></i>
              </FooterAnchor>
              <FooterAnchor href="https://telegram.org/" target="_blank" rel="noopener noreferrer">
                <i className="ri-telegram-line text-xl"></i>
              </FooterAnchor>
              <FooterAnchor href="https://github.com/" target="_blank" rel="noopener noreferrer">
                <i className="ri-github-line text-xl"></i>
              </FooterAnchor>
              <FooterAnchor href="https://discord.com/" target="_blank" rel="noopener noreferrer">
                <i className="ri-discord-line text-xl"></i>
              </FooterAnchor>
            </SocialLinks>
          </FooterSection>
          <FooterSection>
            <FooterTitle>Quick Links</FooterTitle>
            <ul className="space-y-2">
              <li><FooterLink to="/">Home</FooterLink></li>
              <li><FooterLink to="/create-token">Create Token</FooterLink></li>
              <li><FooterLink to="/copy-trending">Trending Tokens</FooterLink></li>
              <li><FooterLink to="/create-liquidity">Create Liquidity</FooterLink></li>
              <li><FooterLink to="/manage-liquidity">Manage Liquidity</FooterLink></li>
              <li><FooterLink to="/faq">FAQ</FooterLink></li>
            </ul>
          </FooterSection>
          <FooterSection>
            <FooterTitle>Resources</FooterTitle>
            <ul className="space-y-2">
              <li><FooterLink to="/learn">Learn</FooterLink></li>
              <li><FooterAnchor href="https://spl.solana.com/token-2022" target="_blank" rel="noopener noreferrer">Docs</FooterAnchor></li>
              <li><FooterAnchor href="https://docs.solana.com/api" target="_blank" rel="noopener noreferrer">API</FooterAnchor></li>
              <li><FooterLink to="/affiliate">Affiliate</FooterLink></li>
              <li><FooterAnchor href="mailto:admin@tokenclub.fun">Contact</FooterAnchor></li>
              <li><FooterAnchor href="http://t.me/tokenlab00" target="_blank" rel="noopener noreferrer">Support</FooterAnchor></li>
            </ul>
          </FooterSection>
        </Grid>
        <FooterBottom>
          <BottomContent>
            <div>© 2025 TokenClub. All rights reserved.</div>
            <PolicyLinks>
              <FooterLink to="/privacy">Privacy Policy</FooterLink>
              <FooterLink to="/terms">Terms of Service</FooterLink>
            </PolicyLinks>
          </BottomContent>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
}

export default Footer;